/**
 * Created by huzhongchun on 2018/5/20.
 */


import React from 'react';
import {Redirect} from 'react-router-dom';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import userInfoActions from 'srcRedux/actions/millionaire/userInfo';
import './style.less';
import qs from 'src/util/queryString';

import './style.less';

class Index extends React.PureComponent {
	constructor(props, context) {
		super(props, context);
		this.state = {
			query: qs.parse(props.location.search),
			loading: true  //增加loading 确保使用最新的接口信息
		};

	}

	componentDidMount(){
		// this.props.userInfoActions.updateAsync({
		// 	success: ()=>{
		// 		this.setState({
		// 			loading: false
		// 		});
		// 	}
		// });
	}

	handleRedirectUrl(){
		let result = '';
		return result;
	}




	render () {
		let url = this.handleRedirectUrl();
		return (
			<React.Fragment>
				<div>首页</div>
			</React.Fragment>
		);
	}
}


function mapStateToProps (state) {
	return {
		userInfo: state.userInfo,
	};
}
function mapDispatchToProps (dispatch) {
	return {
		userInfoActions: bindActionCreators(userInfoActions,dispatch),
	};
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(Index);




// WEBPACK FOOTER //
// ./src/containers/thefair/index/index.js